import React, { useState } from "react";
import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import no_image from "../images/No_Image_Available.jpg";
import { t } from "i18next";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navbar } from "react-bootstrap";
import { getLocalStorageMenuItem, setLocalStorageMenuItem, setMobileBackColor, setMobileTextColor } from "../utility";
import { ArrowBackOutlined } from "@mui/icons-material";
import SaveCustomerNameDialog from "../components/SaveCustomerNameDialog";
import Toast from "../common/toast";
import DOMPurify from 'dompurify';
const PhoneNumberVerificationScreen = ({ tableName, tableQr }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [mobileLoginToken, setMobileLoginToken] = useState(getLocalStorageMenuItem("mobileLoginToken") || "");
    const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || [])
    const [loading, setLoading] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [openSaveNameDialog, setOpenSaveNameDialog] = useState(false);

    const [toastSettings, setToastSettings] = useState({
        open: false,
        message: "",
        success: false,
    });

    const createSanitizedHTML = (html) => {
        return {
            __html: DOMPurify.sanitize(html || '')
        };
    };

    const handleOpenToast = (message, state) => {
        setToastSettings({
            open: true,
            success: state,
            message: message
        });
    };

    const handleCloseToast = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setToastSettings({ open: false, message: "", success: false });
    };

    function useQueryParams() {
        const { search } = useLocation();
        return new URLSearchParams(search);
    }

    const navigate = useNavigate();
    const query = useQueryParams();

    const tParam = query.get("t");
    const lang = query.get("lang");
    const [phone, setPhone] = useState("");

    const validationSchema = Yup.object().shape({
        phoneNumber: Yup.string()
            .required(t("Phone number is required"))
            .test("isValidPhoneNumber", t("Enter a valid phone number"), (value) =>
                isValidPhoneNumber(value || "")
            ),
    });

    const EnterToSections = () => {
        navigate(
            `/${tableName}/${tableQr}/sections?section=0&t=${tParam}&lang=${lang}`
        );
    }

    const handleOpenSaveNameDialog = (token) => {
        setMobileLoginToken(token);
        setOpenSaveNameDialog(true);
    }

    const saveCustomerName = async () => {
        if (!customerName) {

            handleOpenToast(
                <div className="alignByLang">
                    {t("Please enter your name.")}
                </div>
                , false);
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API}/customer/save-name`, {
                name: customerName,
            }, {
                headers: {
                    Authorization: `Bearer ${mobileLoginToken}`,
                }
            });
            if (response?.data?.success) {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Name updated successfully")}
                    </div>
                    , true);

                setMobileLoginToken(mobileLoginToken || "")
                setLocalStorageMenuItem("mobileLoginToken", mobileLoginToken || "")
                setLocalStorageMenuItem("customer_name", customerName || "");
                setLocalStorageMenuItem("customer_balance", 0);
                EnterToSections();
                setOpenSaveNameDialog(false);
            } else {
                handleOpenToast(
                    <div className="alignByLang">
                        {t("Error while saving the name")}
                    </div>
                    , false);
            }
        } catch (error) {

            handleOpenToast(
                <div className="alignByLang">
                    {t("Error while saving the name") + " : " + error.message}
                </div>
                , false);
        } finally {
            setLoading(false);
        }
    };


    const handleSendCode = async (values) => {
        setLoading(true);
        try {
            const sendOtpRes = await axios.post(`${process.env.REACT_APP_API}/customer/send-otp`, {
                'phone': values?.phoneNumber,
                'menu_code': tableQr
            });
            if (sendOtpRes?.data?.success) {
                handleOpenToast(
                    <div className="alignByLang">
                        {t("verification code sent successfully")}
                    </div>
                    , true);
                setLoading(false);

                setDialogOpen(true);


            } else {

                handleOpenToast(
                    <div className="alignByLang">
                        {t("Error while sending the verification code.")}
                    </div>
                    , false);
                setLoading(false);

            }
        } catch (error) {


            handleOpenToast(
                <div className="alignByLang">
                    {t("Error while sending the verification code.") + " " + error.message}
                </div>
                , false);
            setLoading(false);

        }

    };

    const handleVerifyCode = async () => {
        setLoading(true);
        if (verificationCode && verificationCode.length > 0) {
            try {
                const checkOtpRes = await axios.post(`${process.env.REACT_APP_API}/customer/check-otp`, {
                    'phone': phone,
                    'otp': verificationCode
                });
                if (checkOtpRes?.data?.success) {
                    setLocalStorageMenuItem("login_phone", phone)

                    handleOpenToast(
                        <div className="alignByLang">
                            {t("Logged in successfully")}
                        </div>
                        , true);

                    if (checkOtpRes?.data?.data?.name) {
                        setMobileLoginToken(checkOtpRes?.data?.data?.token || "")
                        setLocalStorageMenuItem("mobileLoginToken", checkOtpRes?.data?.data?.token || "");
                        setLocalStorageMenuItem("customer_name", checkOtpRes?.data?.data?.name || "");
                        setLocalStorageMenuItem("customer_balance", checkOtpRes?.data?.data?.balance || 0);
                        EnterToSections();
                        setLoading(false);
                    } else {
                        handleOpenSaveNameDialog(checkOtpRes?.data?.data?.token);

                    }



                } else {


                    handleOpenToast(
                        <div className="alignByLang">
                            {t("Error while logging!")}
                        </div>
                        , false);

                    setLoading(false);

                }
            } catch (error) {
                handleOpenToast(
                    <div className="alignByLang">
                        {t("Error while logging!")}
                    </div>
                    , false);

                setLoading(false);

            }
        } else {


            handleOpenToast(
                <div className="alignByLang">
                    {t("Please enter the verification code!")}
                </div>
                , false);
            setLoading(false);

        }


    };

    const onImageError = (e) => {
        e.target.src = no_image;
    };

    const handleBack = () => {
        navigate(`/${tableName}/${tableQr}/menus?lang=${query.get("lang")}&t=${query.get("t")}`);

    };

    return (
        <div
            className={`min-vh-100`}
            style={{
                backgroundColor:
                    getLocalStorageMenuItem("theme") === "dark" ||
                        getLocalStorageMenuItem("theme") === "costomize"
                        ? setMobileBackColor()
                        : "",
                backgroundImage:
                    getLocalStorageMenuItem("theme") === "dark" ||
                        getLocalStorageMenuItem("theme") === "costomize"
                        ? setMobileBackColor()
                        : "",
            }}
        >
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className="row p-0 m-0">

                <div className="col-lg-4 ms-auto p-0">

                    <div className="slider-mobile">
                        <img
                            src={
                                allTreeData?.details?.cover
                                    ? allTreeData?.details?.cover
                                    : no_image
                            }
                            onError={onImageError}
                            className="slider-mobile-image"
                        />

                        <Navbar
                            className={`d-flex justify-content-between align-items-center mobile-top-nav`}
                            style={{
                                backgroundColor:
                                    getLocalStorageMenuItem("theme") === "dark" ||
                                        getLocalStorageMenuItem("theme") === "customize"
                                        ? setMobileBackColor()
                                        : "",
                            }}
                        >
                            <Button
                                variant="text"
                                className={`ms-2 dark-color cursor`}
                                style={{ color: setMobileTextColor() }}
                                onClick={() => handleBack()}
                            >
                                <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                            </Button>
                            <Navbar.Brand className="text-center">
                                {allTreeData?.data?.data?.details?.logo ? (
                                    <img
                                        src={allTreeData?.data?.data?.details?.logo || no_image}
                                        className="me-4 slider-mobile-logo"
                                        onError={onImageError}
                                    />
                                ) : (
                                    <img
                                        src={no_image}
                                        className="me-4 slider-mobile-logo"
                                        onError={onImageError}
                                    />
                                )}
                            </Navbar.Brand>
                        </Navbar>
                    </div>


                    <div style={{ width: "80%", margin: "auto", marginTop: "20%" }} className="wellcomeScreen text-center">
                        <h1
                            className="mb-2 head-font"
                            style={{ color: setMobileTextColor() }}
                        >
                            {allTreeData?.details?.venu_name || allTreeData?.details?.venu_name}
                        </h1>
                        {/* <p className="head-font" style={{ color: setMobileTextColor() }}>
                            {allTreeData?.details?.description || allTreeData?.details?.description}
                        </p> */}

                        <Box
                            className="head-font"
                            style={{ color: setMobileTextColor() }}
                            dangerouslySetInnerHTML={createSanitizedHTML(getLocalStorageMenuItem("tree_data")?.details?.description || allTreeData?.data?.data?.details?.description)}

                        />
                        <Formik
                            initialValues={{ phoneNumber: "" }}
                            validationSchema={validationSchema}
                            onSubmit={handleSendCode}
                        >
                            {({ values, setFieldValue }) => (
                                <Form style={styles.form}>
                                    <Field name="phoneNumber">
                                        {({ field }) => (
                                            <PhoneInput
                                                className="sub-font"
                                                {...field}
                                                placeholder={t("Enter phone number")}
                                                value={values.phoneNumber}
                                                onChange={(value) => {
                                                    setFieldValue("phoneNumber", value)
                                                    setPhone(value)
                                                }}
                                                defaultCountry="SA"
                                                style={styles.phoneInput}
                                            />
                                        )}
                                    </Field>
                                    <ErrorMessage
                                        name="phoneNumber"
                                        component="div"
                                        style={styles.errorMessage}
                                    />
                                    <Button type="submit" variant="contained" className="head-font" style={styles.button}>
                                        {t("Send Verification Code")}
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
                <Dialog className="alignByLang" open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle className="head-font">{t("Enter Verification Code")}</DialogTitle>
                    <DialogContent className="alignByLang">
                        <TextField
                            className="alignByLang"
                            required
                            label={t("Verification Code")}
                            variant="outlined"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            fullWidth
                            style={styles.verificationCodeInput}

                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleVerifyCode} color="primary">
                            {t("Verify")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <SaveCustomerNameDialog openSaveNameDialogVal={openSaveNameDialog} customerName={customerName} setCustomerNameVal={(cust_name) => setCustomerName(cust_name)} handleSaveCustomerName={saveCustomerName} />
                <Toast
                    open={toastSettings.open}
                    message={toastSettings.message}
                    resetToast={handleCloseToast}
                    success={toastSettings.success}
                />
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '20px',
    },
    profileImage: {
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        marginBottom: '20px',
    },
    form: {
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
    },
    phoneInput: {
        marginBottom: '20px',
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '10px',
        fontSize: '16px',
    },
    errorMessage: {
        color: 'red',
        marginBottom: '10px',
    },
    button: {
        width: '100%',
    },
    verificationCodeInput: {
        marginBottom: '20px',
        textAlign: "center"
    },
};

export default PhoneNumberVerificationScreen;
